registerComponent("sections/wa-recursos", function (component) {
/**
 * sections/wa-recursos — "O que você resolve por aqui".
 *
 * O trilho de bolhas anda SOZINHO, no CSS (`@keyframes wa-recursos-anda`), e
 * para sob o ponteiro pelo `animation-play-state` (ADR 0118) — o compositor
 * faz tudo sem JS. Aqui ficam a entrada (`.entrada`, `_entrada.less` / ADR
 * 0051) do título, do lead e do trilho, e o TOQUE: num celular não há hover,
 * então um toque no trilho pausa e outro retoma.
 *
 * ⚠️ O laço também PAUSA com a aba oculta, e isso é do navegador: uma
 * `animation` de CSS não avança em documento escondido. É o comportamento
 * desejado (não gastar quadro à toa) e é o motivo de o movimento ser
 * `@keyframes` e não `requestAnimationFrame`.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

if (Asa.movimentoPermitido()) {
    Asa.armarEntrada([component], '.entrada');
}

/* O TOQUE PAUSA E RETOMA (24/09, pedido do cliente). `pointerup` só com dedo
   ou caneta — o mouse já tem o hover —, e só num toque de verdade: se o dedo
   arrasta a página, o navegador manda `pointercancel` no lugar do `pointerup`,
   e a rolagem não mexe no trilho. */
const trilho = component.querySelector('.wa-recursos__trilho');

if (trilho) {
    trilho.addEventListener('pointerup', (evento) => {
        if (evento.pointerType === 'mouse') {
            return;
        }

        component.classList.toggle('wa-recursos--pausado');
    });
}

});
